import clsx from 'clsx'
import React from 'react'
import {makeStyles} from 'external/material'
import Box from '@mui/material/Box'
import Radio from '@mui/material/Radio'
import RadioGroup from '@mui/material/RadioGroup'
import Fade from '@mui/material/Fade'
import FormControlLabel from '@mui/material/FormControlLabel'
import StatusIcon from '../StatusIcon'

const useStyles = makeStyles(trueOrFalseStyles)

export default function TrueOrFalse ({context, section, question, questionIndex}) {

  const classes = useStyles()
  const {quizAssessmentResults: assessment, translate} = context

  const {answers = {}} = assessment 
  const answer = answers[question.id] || {}

  const correct = question.answer.value == answer.value

  return (
    <Box className={classes.root}>
      <RadioGroup className="content" value={answer.value}>
        <Box className={classes.option}>
          <StatusIcon value={true} answer={answer.value} correctAnswer={question.answer.value} />
          <Box className={classes.radio}>
            <FormControlLabel value={true} control={<Radio />} label={translate('true')} />
          </Box>
        </Box>
        <Box className={classes.option}>
          <StatusIcon value={false} answer={answer.value} correctAnswer={question.answer.value} />
          <Box className={classes.radio}>
            <FormControlLabel value={false} control={<Radio />} label={translate('false')} />
          </Box>
        </Box>
      </RadioGroup>
    </Box>
  )
}

function trueOrFalseStyles (theme) {
  return {
    root: {
    },
    option: {
      display: 'flex'
    }
  }
}
